import { apiClient } from "../config";

export const createBinancePayOrder = async (data: any) => {
  return apiClient.post("/v2/payments/binance/createOrder", data);
};
